<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="1400"
        :height="655"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">STEP 2/2 : SELECT MEMBERS OR TEAMS</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout p-6 h-100">
                        <div class="d-flex" style="height: 90%; overflow-x: hidden; overflow-y: auto">
                            <div class="pr-4" style="width: 60%; border-right: 2px solid #e2e2e2">
                                <div class="d-flex" style="background: #f3f3f3; border-radius: 20px;">
                                    <i class="icon icon-magnify grey-search ml-4 mr-2" style="border-radius: 0; background: transparent; font-size: 25px; margin-top: 7px;"></i>
                                    <input class="grey-search-input" type="text" placeholder="Search by Name" v-model="search_key" @input="show == 'members' ? getMembers() : getTeams()" style="color: #303031; width: 100%; background: transparent; height: 37px;" />
                                </div>
                                <div class="content-area">
                                    <div class="row pt-4 px-4 mt-4">
                                        <div class="col-lg-12">
                                            <div class="header-tabs mb-4">
                                                <div class="header-options pointer" :class="show == 'members' ? 'header-options-selected' : ''" @click="membersClicked">
                                                    Members
                                                </div>
                                                <div class="header-options pointer" :class="show == 'teams' ? 'header-options-selected' : ''" @click="teamsClicked">
                                                    Teams
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="show == 'members'" class="row pb-4 px-4">
                                        <div v-for="(member,index) in members" :key="index" class="col-lg-6 mb-4">
                                            <div class="member-info">
                                                <div class="d-flex flex-wrap align-items-center justify-content-between">
                                                    <div class="d-flex flex-wrap">
                                                        <img :src="member.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="40px" height="40px" style="border-radius: 50%;">
                                                        <div class="d-flex flex-wrap flex-column ml-2">
                                                            <span class="fs-15">{{ member.full_name }}</span>
                                                            <span class="fs-12 email" style="color: #949494;">{{ member.email_id }}</span>
                                                        </div>
                                                    </div>
                                                    <label class="checkbox-label mr-2">
                                                        <input class="checkbox" type="checkbox" :checked="membersSelected.includes(member)" @click="memberSelected(member)" />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="show == 'teams'" class="row pb-4 px-4">
                                        <div v-for="(team,index) in teams" :key="index" class="col-lg-6 mb-4">
                                            <div class="member-info">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex">
                                                        <img :src="team.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="40px" height="40px" style="border-radius: 50%;">
                                                        <div class="d-flex flex-column ml-2">
                                                            <span class="fs-15 mr-2">{{ team.name }}</span>
                                                            <span class="fs-12" style="color: #949494;">{{ team.email }}</span>
                                                        </div>
                                                    </div>
                                                    <label class="checkbox-label">
                                                        <input class="checkbox" type="checkbox" :checked="teamsSelected.includes(team)" @click="teamSelected(team)" />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pl-4" style="width: 40%; border-left: 2px solid #e2e2e2">
                                <div class="my-4">
                                    <div class="d-flex align-items-center mt-6">
                                        <i class="con icon-arrow-down-drop pointer" :style="showMembers ? 'transform: rotate(0deg)' : 'transform: rotate(-90deg)'" @click="showMembers = !showMembers"></i>
                                        <div class="tabs" @click="showMembers = !showMembers">
                                            Members ({{ membersSelected.length }})
                                        </div>
                                    </div>
                                    <div class="row mt-2" v-if="showMembers">
                                        <div v-for="(member,index) in membersSelected" :key="index" class="col-lg-6 my-2">
                                            <div class="selected-members d-flex justify-content-between align-items-center">
                                                <div class="d-flex align-items-center" style="overflow: hidden">
                                                    <img :src="member.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="35px" height="35px" style="border-radius: 50%;">
                                                    <span class="fs-12 fw-500 ml-2" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ member.full_name }}</span>
                                                </div>
                                                <span class="icon icon-close mr-2 pointer" style="font-size: 18px" @click="memberSelected(member)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="my-4">
                                    <div class="d-flex align-items-center mt-4">
                                        <i class="con icon-arrow-down-drop pointer" :style="showSelectedMembers ? 'transform: rotate(0deg)' : 'transform: rotate(-90deg)'" @click="showSelectedMembers = !showSelectedMembers"></i>
                                        <div class="tabs" @click="showSelectedMembers = !showSelectedMembers">
                                            Selected Teams ({{ teamsSelected.length }})
                                        </div>
                                    </div>
                                    <div class="row mt-2" v-if="showSelectedMembers">
                                        <div v-for="(team,index) in teamsSelected" :key="index" class="col-lg-6 my-2">
                                            <div class="selected-members d-flex justify-content-between align-items-center">
                                                <div>
                                                    <img :src="team.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="35px" height="35px" style="border-radius: 50%;">
                                                    <span class="fs-12 fw-500 ml-2">{{ team.name }}</span>
                                                </div>
                                                <span class="icon icon-close mr-2 pointer" style="font-size: 18px" @click="teamSelected(team)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-end" style="height: 10%">
                            <button v-if="show == 'members' ? members.length != membersSelected.length : teams.length != teamsSelected.length" class="btn btn-des-small mr-4"  style="background: transparent; color: #00448b; border: 1px solid #00448b; width: 10em" @click="selectAll">Select All</button>
                            <button v-if="show == 'members' ? members.length == membersSelected.length : teams.length == teamsSelected.length" class="btn btn-des-small mr-4"  style="background: transparent; color: #00448b; border: 1px solid #00448b; width: 10em" @click="show == 'members' ? membersSelected = [] : teamsSelected = []">Deselect All</button>
                            <button class="btn btn-new-primary btn-des-small ml-4" style="width: 10em" @click="createTeam">Create Team</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <members-added modal_name="membersAdded" :team_name="team_name"></members-added>
    </div>
</template>

<script>
import MembersAdded from "./alertModals/MembersAdded";
export default {
    data() {
        return {
            storedTeamInfo: {},
            showMembers: true,
            showSelectedMembers: true,
            show: "members",
            members: [],
            teams: [],
            membersSelected: [],
            teamsSelected: [],
            search_key: "",
        }
    },
    props: ["modal_name","team_id","team_name"],
    components: {
        MembersAdded
    },
    methods: {
        hideSelf() {
            this.storedTeamInfo = {};
            this.showMembers = true;
            this.showSelectedMembers = true;
            this.show = "members";
            this.members = [];
            this.teams = [];
            this.membersSelected = [];
            this.teamsSelected = [];
            this.search_key = "";
            localStorage.clear();
            this.$modal.hide(this.modal_name);
        },
        membersClicked() {
            this.search_key = "";
            this.show = "members";
            this.getMembers();
        },
        teamsClicked() {
            this.search_key = "";
            this.show = "teams";
            this.getTeams();
        },
        memberSelected(member) {
            if (this.membersSelected.includes(member)) {
                this.membersSelected = this.membersSelected.filter(x => x != member);
            } else {
                this.membersSelected.push(member);
            }
        },
        teamSelected(team) {
            if (this.teamsSelected.includes(team)) {
                this.teamsSelected = this.teamsSelected.filter(x => x != team);
            } else {
                this.teamsSelected.push(team);
            }
        },
        selectAll() {
            if (this.show == "members") {
                this.members.forEach(x => {
                    if (!this.membersSelected.includes(x)) {
                        this.membersSelected.push(x);
                    }
                });
            } else if (this.show == "teams") {
                this.teams.forEach(x => {
                    if (!this.teamsSelected.includes(x)) {
                        this.teamsSelected.push(x);
                    }
                });
            }
        },
        async getMembers() {
            let params = {
                search_key: this.search_key,
                skip: 0,
                limit: 10,
                company_id: this.selectedCompany._id,
                active_status: "active",
            };
            let res = await this.$http.post("/employees/get_employees", params);
            if (res.data.status_id == 1) {
                this.members = res.data.response;
            }
        },
        async getTeams() {
            let params = {
                limit: 10,
                skip: 0,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/teams/get_teams_list", params);
            if (res.data.status_id == 1) {
                this.teams = res.data.response;
            }
        },
        async createTeam() {
            this.storedTeamInfo = JSON.parse(localStorage.getItem('teamInfo'));
            let params = {
                description: this.storedTeamInfo.description,
                email: this.storedTeamInfo.email,
                members: [...new Set(this.membersSelected.map(x => x._id))],
                teams: [...new Set(this.teamsSelected.map(x => x._id))],
                name: this.storedTeamInfo.name,
            };
            if (params.members.length == 0) {
                delete params["members"];
            }
            if (params.teams.length == 0) {
                delete params["teams"];
            }
            let res = await this.$http.post("/teams/save", params);
            if (res.data.status_id == 1) {
                this.$emit("newTeamName", this.storedTeamInfo.name);
                this.hideSelf();
                this.$modal.show("teamCreated");
            }
        },
        async addMembers() {
            let params = {
                members: [...new Set(this.membersSelected.map(x => x._id))],
                teams: [...new Set(this.teamsSelected.map(x => x._id))],
                team_id: this.team_id,
            };
            if (params.members.length == 0) {
                delete params["members"];
            }
            if (params.teams.length == 0) {
                delete params["teams"];
            }
            let res = await this.$http.post("/team_members/add", params);
            if (res.data.status_id == 1) {
                this.$modal.show("membersAdded");
                setTimeout(() => {
                    this.$modal.hide("membersAdded");
                }, 1000);
                this.hideSelf();
            }
        }
    },
    created() {
        this.getMembers();
    },
    computed: {
        selectedCompany() {
            return this.$store.getters.selectedCompany;
        },
    }
}
</script>

<style scoped>
    .content-area {
        background: #e8efff;
    }
    .member-info {
        background: #fff;
        border-radius: 5px;
        padding: 10px;
    }
     /* Customize the label (the checkbox-label) */
    .checkbox-label {
        display: block;
        position: relative;
        padding-left: 20px;
        margin-bottom: 18px;
        cursor: pointer;
        font-size: 22px;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: transparent;
        border: 2px solid #038e1f;
        border-radius: 4px;
    }

    /* When the checkbox is checked, add a blue background */
    .checkbox-label input:checked ~ .checkmark {
        background-color: #038e1f;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checkbox-label input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkbox-label .checkmark:after {
        left: 5px;
        top: 2px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .selected-members {
        border-radius: 20px;
        background: #e8efff;
    }

    .tabs {
        font-size: 14px;
        font-weight: 500;
    }

    .tabs:hover {
        cursor: pointer;
    }

    .header-tabs {
        border-radius: 10px;
        background: #fff;
        display: flex;
    }

    .header-options {
        border-radius: 10px;
        padding: 12px 0px;
        text-align: center;
        width: 100%;
        font-weight: 500;
        font-size: 15px;
        color: #2b6ad0;
    }

    .header-options-selected {
        background: #2b6ad0 !important;
        color: #fff !important;
    }
	@media only screen and (max-width: 550px)  {
        .email{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 100px;
        }
        .profile-name{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 120px;
        }
        .checkbox-label{
            margin-left: 5px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/components/AddNewMembersModal.vue